import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  templateUrl: './inventory-refrigerators-dialog.component.html'
})
export class InventoryRefrigeratorsDialogComponent {
  public refrigeratorsConfig: any;

  constructor(private matDialogRef: MatDialogRef<InventoryRefrigeratorsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.refrigeratorsConfig = this.data.refrigeratorsConfig;
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }
}
